<div class="h-full overflow-hidden">
  <div class="flex border-b justify-between gap-4 w-full p-4 text-xl font-bold items-center">
    <div class="flex gap-3 items-center">
      <wun-editorials-icon />
      Blog
    </div>
    <div>
      <button wunButton primary>Nuovo</button>
    </div>
  </div>
  <div class="flex h-full flex-1 overflow-auto">
    <wun-form-blog />
  </div>
</div>
